// extracted by mini-css-extract-plugin
export default {"container":"vC-z","dimension":"wC-z","dimensionLabels":"xC-z"};